  import React from 'react';
  import QuotationLogo from '../assets/QuotationLogo.png';

  export const QuotationTemplete = ({ data }) => {
    // Use mock data if no data provided
    const quotation = data || {
      projectName: "-",
      clientName: "Mrs Rama Garu",
      date: "29th Jan 2026",
      site: "Hyderabad",
      quotationNo: "VK/63-C/2026",
      contactRef: "",
      designer: "Srirupa",
      stoneSlabs: [
        {
          name: "MAGIC NIGHT - AD-104-2",
          colour: "As per design",
          type: "Marine club",
          warranty: "7 years of warranty",
          amount: "67,500.00",
          details: [
            "Full slab : 51 sft",
            "- First floor powder room",
            "-Kid's bathroom",
            "-Second floor master bathroom",
            "-Second floor Home theater"
          ]
        },
        {
          name: "HAFELE : FOSSILE - 564:42:163",
          colour: "As per design",
          type: "Marine club",
          warranty: "7 years of warranty",
          amount: "1,23,649.00",
          details: [
            "Full slab : 54 sft",
            "- First floor guest room",
            "-First floor master bathroom"
          ]
        },
        {
          name: "LAVENDER CREST",
          colour: "As per design",
          type: "Marine club",
          warranty: "7 years of warranty",
          amount: "1,22,400.00",
          details: [
            "Full slab : 51 sft",
            "Slab qty : 2"
          ],
          highlight: true
        }
      ],
      interiors: [
        {
          name: "CONSOLE UNIT",
          colour: "As per design",
          type: "Marine club",
          warranty: "7 years of warranty",
          amount: "97,000.00",
          details: [
            "Base unit : Fully modular with carcass as 18 mm thickness,",
            "internal as linear lamiante.",
            "Shutters & exposed facia with PU finish.",
            "Handles : gola profile",
            "",
            "Hardware : Blum"
          ]
        },
        {
          name: "POOJA UNIT",
          colour: "As per design",
          type: "Marine club",
          warranty: "7 years of warranty",
          amount: "1,17,600.00",
          details: [
            "Base unit : Fully modular with carcass as 18 mm thickness,",
            "internal as linear lamiante.",
            "Shutters & exposed facia with PU finish.",
            "Handles : gola profile",
            "Pooja Doors : Profile with Bells .",
            "",
            "Hardware : Blum"
          ],
          highlight: true
        }
      ],
      appliances: [
        {
          name: "APPLIANCE",
          colour: "As per design",
          type: "Marine club",
          warranty: "7 years of warranty",
          amount: "42,490.00",
          details: [
            "Brass burners to sear, simmer and pan fry.",
            "Blue flame burns efficiently to lower energy cost.",
            "Mini triple-ring burner for intense, even heat.",
            "ELECTROLUX : EHG643OBC"
          ],
          image: "https://www.electrolux.in/globalassets/pim-data/image/product-image-electrolux-ehg6430bc-black.jpg", // generic placeholder
          highlight: false
        }
      ],
      totals: {
        total: "16,99,830.00",
        discount: "2,00,000.00",
        grandTotal: "14,99,830.00"
      }
    };

    return (
      <div className="w-[800px] mx-auto bg-white text-black font-sans text-[11px] print:m-0 print:w-[800px] print:max-w-none">
        
        {/* HEADER */}
        <div className="flex w-full border-2 border-black border-b-0 h-[140px]">
          <div className="flex-[2.5] bg-[#bcbcbc] flex flex-col items-center justify-end pb-1 pt-6 relative border-r-2 border-black">
            <h1 className="text-[40px] font-normal tracking-wide text-black mb-6">VERVE KITCHENS</h1>
            <p className="font-bold text-[11px] text-black w-full text-center">
              KVR Holdings Plot # 715, Jublie Hills Road no-36, Hyderabad-500033
            </p>
          </div>
          <div className="flex-1 bg-black flex items-center justify-center p-3">
            <img src={QuotationLogo} alt="Verve Kitchens" className="h-full object-contain" />
          </div>
        </div>

        {/* QUOTATION STRIP */}
        <div className="bg-black text-white text-center py-0.5 font-bold text-[12px] border-2 border-black border-b-0 border-t-0">
          QUOTATION
        </div>

        {/* CLIENT DETAILS TABLE */}
        <table className="w-full border-2 border-black border-collapse table-fixed">
          <tbody>
            <tr className="border-b border-black">
              <td className="w-[30%] border-r border-black px-2 py-0.5">Project Name : {quotation.projectName}</td>
              <td className="w-[20%] border-r border-black px-2 py-0.5">{quotation.clientName}</td>
              <td className="w-[25%] border-r border-black px-2 py-0.5">Date :</td>
              <td className="w-[25%] px-2 py-0.5 text-center">{quotation.date}</td>
            </tr>
            <tr className="border-b border-black">
              <td className="w-[30%] border-r border-black px-2 py-0.5">Site</td>
              <td className="w-[20%] border-r border-black px-2 py-0.5">{quotation.site}</td>
              <td className="w-[25%] border-r border-black px-2 py-0.5">Quotation No.</td>
              <td className="w-[25%] px-2 py-0.5 text-center">{quotation.quotationNo}</td>
            </tr>
            <tr className="border-b border-black">
              <td className="w-[30%] border-r border-black px-2 py-0.5">Contact Ref:</td>
              <td className="w-[20%] border-r border-black px-2 py-0.5"></td>
              <td className="w-[25%] border-r border-black px-2 py-0.5">Reference / Designer</td>
              <td className="w-[25%] px-2 py-0.5 text-center">{quotation.designer}</td>
            </tr>
          </tbody>
        </table>

        {/* PROJECT DETAILS - INTERIORS */}
        <div className="bg-[#b4b4b4] text-white text-center py-0.5 font-bold text-[11px] border-x-2 border-black">
          PROJECT DETAILS - INTERIORS
        </div>
        
        {/* EMPTY DIVIDER ROW */}
        <div className="flex border-x-2 border-black bg-white">
          <div className="w-[45%] border-r border-black h-[14px]"></div>
          <div className="flex-1 h-[14px]"></div>
        </div>
        
        <div className="bg-[#b4b4b4] text-white text-center py-0.5 font-bold text-[11px] border-x-2 border-black">
          STONE SLABS
        </div>

        {/* MAIN DATA TABLE */}
        <table className="w-full border-2 border-black border-collapse table-fixed">
          <thead>
            <tr className="border-y-2 border-black bg-[#e6e6e6]">
              <th className="w-[45%] border-r-2 border-black px-2 py-1 text-left font-bold text-[13px]">Particulars</th>
              <th className="w-[25%] border-r-2 border-black px-2 py-1 text-center font-bold text-[13px]">Colour / Type</th>
              <th className="w-[15%] border-r-2 border-black px-2 py-1 text-center font-bold text-[13px]">Warranty</th>
              <th className="w-[15%] px-2 py-1 text-right font-bold text-[13px]">Amount</th>
            </tr>
          </thead>
          <tbody>
            {/* STONE SLABS LOOP */}
            {quotation.stoneSlabs?.map((item, idx) => (
              <React.Fragment key={`stone-${idx}`}>
                <tr className={`border-b border-black ${item.highlight ? 'bg-[#fce9d5]' : 'bg-white'}`}>
                  <td className="border-r-2 border-black px-2 py-0.5 font-bold text-[13px]">{item.name}</td>
                  <td className="border-r-2 border-black px-2 py-0.5 text-gray-700">{item.colour}</td>
                  <td className="border-r-2 border-black px-2 py-0.5 text-center text-gray-700">{item.warranty}</td>
                  <td className="px-2 py-0.5 text-right font-bold">{item.amount}</td>
                </tr>
                <tr className={`border-b-2 border-black ${item.highlight ? 'bg-[#fce9d5]' : 'bg-white'}`}>
                  <td className="border-r-2 border-black px-2 py-1 text-gray-900 align-top">
                    {item.details.map((line, i) => (
                      <div key={i} className={line.includes('Full slab') || line.includes('Slab qty') ? 'font-medium' : ''}>
                        {line}
                      </div>
                    ))}
                  </td>
                  <td className="border-r-2 border-black px-2 py-1 align-top text-gray-700">{item.type}</td>
                  <td className="border-r-2 border-black px-2 py-1"></td>
                  <td className="px-2 py-1"></td>
                </tr>
              </React.Fragment>
            ))}

            {/* INTERIORS STRIP */}
            <tr className="bg-[#b4b4b4] border-b-2 border-black">
              <td colSpan="4" className="text-center text-white font-bold py-0.5 text-[13px]">INTERIORS</td>
            </tr>

            {/* INTERIORS LOOP */}
            {quotation.interiors?.map((item, idx) => (
              <React.Fragment key={`interior-${idx}`}>
                <tr className={`border-b border-black ${item.highlight ? 'bg-[#fce9d5]' : 'bg-white'}`}>
                  <td className="border-r-2 border-black px-2 py-0.5 font-bold text-[13px]">{item.name}</td>
                  <td className="border-r-2 border-black px-2 py-0.5 text-gray-700">{item.colour}</td>
                  <td className="border-r-2 border-black px-2 py-0.5 text-center text-gray-700">{item.warranty}</td>
                  <td className="px-2 py-0.5 text-right font-bold">{item.amount}</td>
                </tr>
                <tr className={`border-b-2 border-black ${item.highlight ? 'bg-[#fce9d5]' : 'bg-white'}`}>
                  <td className="border-r-2 border-black px-2 py-1 text-gray-900 align-top leading-tight">
                    {item.details.map((line, i) => {
                      if (line.includes('Base unit :')) {
                        return <div key={i}><span className="font-bold">Base unit :</span>{line.split('Base unit :')[1]}</div>;
                      }
                      if (line.includes('Pooja Doors :')) {
                        return <div key={i}><span className="font-bold">Pooja Doors :</span>{line.split('Pooja Doors :')[1]}</div>;
                      }
                      if (line === "") return <div key={i} className="h-2"></div>;
                      return <div key={i}>{line}</div>;
                    })}
                  </td>
                  <td className="border-r-2 border-black px-2 py-1 align-top text-gray-700">{item.type}</td>
                  <td className="border-r-2 border-black px-2 py-1"></td>
                  <td className="px-2 py-1"></td>
                </tr>
              </React.Fragment>
            ))}

            {/* APPLIANCES LOOP */}
            {quotation.appliances?.map((item, idx) => (
              <React.Fragment key={`appliance-${idx}`}>
                <tr className="border-b border-black bg-white" style={{ pageBreakInside: 'avoid' }}>
                  <td className="border-r-2 border-black px-2 py-0.5 font-bold text-[13px] uppercase">{item.name}</td>
                  <td className="border-r-2 border-black px-2 py-0.5 text-gray-700">{item.colour}</td>
                  <td className="border-r-2 border-black px-2 py-0.5 text-center text-gray-700">{item.type}</td>
                  <td className="px-2 py-0.5 text-right font-bold">{item.amount}</td>
                </tr>
                <tr className="border-b-2 border-black bg-white" style={{ pageBreakInside: 'avoid' }}>
                  <td className="border-r-2 border-black px-2 py-1 text-gray-900 align-top leading-tight">
                    {item.details.map((line, i) => (
                      <div key={i} className={line.includes('ELECTROLUX') ? 'font-medium text-gray-600 mt-2 uppercase' : 'text-gray-500'}>
                        {line}
                      </div>
                    ))}
                  </td>
                  <td colSpan="2" className="border-r-2 border-black px-2 py-2 align-middle text-center">
                    {item.image && (
                      <img src={item.image} alt="Appliance" style={{ maxHeight: '90px', margin: '0 auto', display: 'block', objectFit: 'contain' }} />
                    )}
                  </td>
                  <td className="px-2 py-1"></td>
                </tr>
              </React.Fragment>
            ))}

            {/* TOTALS */}
            <tr className="bg-white border-b border-black" style={{ pageBreakInside: 'avoid' }}>
              <td colSpan="3" className="border-r-2 border-black px-2 py-1 text-right font-bold uppercase text-[13px] text-gray-700">
                TOTAL
              </td>
              <td className="px-2 py-1 text-right font-bold">{quotation.totals?.total}</td>
            </tr>
            <tr className="bg-white border-b border-black" style={{ pageBreakInside: 'avoid' }}>
              <td colSpan="3" className="border-r-2 border-black px-2 py-1 text-right font-bold uppercase text-[13px] text-gray-700">
                SPECIAL DISOUNT
              </td>
              <td className="px-2 py-1 text-right font-bold">{quotation.totals?.discount}</td>
            </tr>
            <tr className="bg-white border-b-2 border-black" style={{ pageBreakInside: 'avoid' }}>
              <td colSpan="3" className="border-r-2 border-black px-2 py-1 text-right font-bold uppercase text-[13px] text-gray-800">
                GRAND TOTAL
              </td>
              <td className="px-2 py-1 text-right font-bold">{quotation.totals?.grandTotal}</td>
            </tr>
          </tbody>
        </table>

        {/* TAXES EXTRA */}
        <div style={{ padding: '2px 4px', fontWeight: 'bold', fontSize: '10px' }}>
          *TAXES EXTRA
        </div>

        <div style={{ height: '8px' }}></div>

        {/* TERMS INFORMATION */}
        <table className="w-full border-2 border-black border-collapse table-fixed" style={{ pageBreakInside: 'avoid' }}>
          <tbody>
            <tr className="bg-[#e6e6e6] border-b-2 border-black">
              <td className="text-center font-bold py-1 text-[13px] uppercase tracking-wide text-black">
                TERM INFORMATION:-
              </td>
            </tr>
            <tr>
              <td className="px-3 py-3 align-top leading-[1.4] text-[13px] text-black">
                <div style={{ fontWeight: 'bold', textDecoration: 'underline', marginBottom: '4px' }}>
                  A WELL PLANNED KITCHEN WITH EXCELLENT FINISH WILL BE UNDER OUR SCOPE
                </div>
                <div>1)All the above modules have MARINE CLUB Material Carcass, <span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>Blum</span> Hardware.</div>
                <div>2)All hardware of <span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>Blum</span> Brand-Life time warranty : Soft closing Drawers</div>
                <div>3)Delivery date of the materials will depend on the final signoff copy / declaration of client.</div>
                <div>4)Final drawings (3d renders , 2d drawings , electrical drawings ) with material specs will be submitted to the client after token advance.</div>
                <div>5)Token advance amount will be adjust in the final amount , the payment will be scheduled as per the shared abstract.</div>
                <div>6)Handles will be of Gola .</div>
                <div style={{ fontWeight: 'bold', fontStyle: 'italic' }}>7)The final revision of quote will be re-sent to clients once the final measurement is taken (after flooring & ceiling).</div>
                <div style={{ fontWeight: 'bold', fontStyle: 'italic', marginBottom: '2px' }}>Token advance : Rs 1,00,000/-</div>
                <div>8)Delivery of Material within 50-55 days from the day of final measurment<br />   of kitchen & 5-6 days for fitting.</div>
                <div>9)Please note this quote is exclusive of <span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>accessories</span> .</div>
                
                <div style={{ fontWeight: 'bold', textDecoration: 'underline', marginTop: '6px', marginBottom: '2px', textAlign: 'center', paddingRight: '20px' }}>
                  PAYMENT DETAILS
                </div>
                <div style={{ fontWeight: 'bold' }}>10)CQ in the name of V Cube Modular Systems</div>
                <div style={{ fontWeight: 'bold' }}>11)Payment terms:-50% advance, 50% 2 days before dispatch; installation next day as per site ready</div>
                <div style={{ fontWeight: 'bold' }}>12)Local Taxes Applicable@18%</div>
                <div style={{ fontWeight: 'bold' }}>13)Payments can be made under ;</div>
                
                <div style={{ marginLeft: '12px', marginTop: '2px' }}>
                  <div style={{ fontWeight: 'bold' }}>NAME : VCUBE MODULAR SYSTEMS.</div>
                  <div style={{ fontWeight: 'bold' }}>A/C : 3872015322 .</div>
                  <div style={{ fontWeight: 'bold' }}>BANK: CENTRAL BANK OF INDIA.</div>
                  <div style={{ fontWeight: 'bold' }}>BRANCH: JUBLIEE HILLS BRANCH.</div>
                  <div style={{ fontWeight: 'bold' }}>RTGS NO: CBIN0283638</div>
                </div>

                <div style={{ fontWeight: 'bold', marginTop: '16px' }}>
                  Advance amount once paid will not be refunded **
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  export default QuotationTemplete;
